module.exports = __webpack_public_path__ + "img/69_M11_hello_hurricanes.4a7e2fc2.jpg";